const Instructions = () => {
  return (
    <div className="instructions">
      <p>
        When you're ready, click the "Ready to Rock" button above to start your timer and begin writing!
      </p>
      <p>
        Keep writing! After 15 seconds of no typing, a popup will appear and we will gently prompt you to keep going.
      </p>
      <p>
        This is your space to write freely - don't fret too much about spelling or grammar, just get those words on the page! You got this!
      </p>
      <p>
        If you'd like to reset your timer length or prompt, click the "Restart" button below.
      </p>
    </div>
  )
}

export default Instructions;